import { useDispatch } from "react-redux";
import Button from "../../UI/Button"
import TYPES from "../TYPES";
import { closeModal } from "@store/modalsSlise";
import s from './index.module.css';

const Confirmation = ({
    data
}) => {
    const dispatch = useDispatch();
    const close = () => dispatch(
        closeModal({
            type: TYPES.CONFIRMATION
        })
    )
    return (<>
        <div className={s.title}>{ data.title }</div>
        <div className={s.buttons}>
            <Button newDesign onClick={() => {
                data.yes()
                close()
            }}>Да</Button>
            <Button newDesign onClick={close}>Нет</Button>
        </div>
    </>)
}

export default Confirmation;